var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tree',{attrs:{"checkable":"","tree-data":_vm.data,"expanded-keys":_vm.columnExpandedKeys},on:{"check":_vm.columnCheck,"expand":_vm.columnExpand},model:{value:(_vm.selectColumnKeys),callback:function ($$v) {_vm.selectColumnKeys=$$v},expression:"selectColumnKeys"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }